<template>
  <div class="theBackgroundColor">
    <div class="shareRankingBigBox">
      <div class="columnBackground">
        <img src="../assets/image/newbg_02.jpg" alt="" />
      </div>
      <div class="shareContent">
        <!-- <div class="sharedOnTheLeftSideOfThe">
          <div class="onTheLeftSideOfTheTitle">最新资讯</div>
          <ul>
            <li
              v-for="(item, index) in theListShows"
              :key="index"
              :class="{ colorStyle: currentIndex === index }"
              @click="columnClick(index, item.id)"
            >
              <span class="theColumnChangeColor">{{ item.name }}</span
              ><span class="arrow-right"></span>
            </li>
          </ul>
        </div> -->

        <div class="sharingOnTheRightSide">
          <div class="theBreadCut">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item to="/newlist">最新资讯</el-breadcrumb-item>
              <el-breadcrumb-item>{{ tableData.title }}</el-breadcrumb-item>
          
            </el-breadcrumb>
          </div>

          <div class="theRightSideOfTheTableFrame">
            <div class="inTopForm">
              <div class="article-box cf">
                <div class="art-title cf">
                  <h2 class="f-34 f-b center">{{ tableData.title }}</h2>
                  <p style="text-align: center"></p>
                  <div class="basic-list f-16 cf">
                    <span>作者：{{ tableData.author }}</span>
                    <span>时间：{{ tableData.publishTime }}</span>
                  </div>
                </div>

                <div class="art-text-box f-16 cf" v-html="tableData.content.replace(/\    /g,'<br/>')" style="white-space:pre-wrap">
               
                </div>

                <!-- <div class="pager f-14 cf">
            <p class="ellipsis">
              <span class="f-16">上一篇：</span>
              <a href="9.html"
                >2019年辽宁省虚拟仿真实验教学项目、大学生校外实践基地填报指南</a
              >
            </p>
          </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  informTheDetails,
} from "../assets/api/index";
import router from "../router/index.js";
import { useRoute } from 'vue-router';
export default {
  setup() {

    const Route = useRoute(); //获取到值

    //资讯点击



    
    const tableData = ref([]);

    const getData = () => {
      informTheDetails(Route.query.newsid).then((res) => {
          tableData.value = res.data;
        }
      );
    };
    getData();
 
    return {
      tableData,
      getData
     
    };
  },

  name: "informationForDetails"
};
</script>

<style src="../assets/css/inner.css"  scoped></style>
<style src="../assets/css/information.css"  scoped></style>
<style  scoped>
.theBackgroundColor {
  background: #f4f4f4;
}
.columnBackground {
  text-align: center;
}
.shareContent {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.colorStyle .theColumnChangeColor {
  color: #a50c0d;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 7px solid #fff;
  border-bottom: 7px solid #fff;
  border-left: 7px solid #a50c0d;
  position: relative;
  left: 14px;
  top: 2px;
  display: none;
}
.colorStyle .arrow-right {
  display: inline-block;
}
.inTopForm {
  margin-top: 30px;
}
.inTopForm ul li {
  font-size: 16px;
  height: 23px;
  margin-bottom: 20px;
  cursor: pointer;
}
.theArticleDate {
  float: right;
  font-size: 12px;
  color: #707070;
  line-height: 23px;
}
.sharedOnTheLeftSideOfThe {
  width: 216px;
  margin-right: 20px;
  position: relative;
  bottom: 60px;
}
.onTheLeftSideOfTheTitle {
  width: 216px;
  height: 60px;
  background: #a50c0d;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center;
  font-size: 20px;
  line-height: 60px;
  color: #fff;
}

.theOrigin {
  background: #a50c0d;
  width: 5px;
  height: 5px;
  display: inline-block;
  border-radius: 5px;
  position: relative;
  bottom: 4px;
  margin-right: 13px;
}
.sharedOnTheLeftSideOfThe ul li {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}
.sharedOnTheLeftSideOfThe ul {
  /*! border: 1px solid #eee; */
  background: #fff;
}
.sharingOnTheRightSide {
  width: 100%;
  min-height: 0;
  background: #fff;
  border-top: 2px solid #a50c0d;
  padding: 0 31px 0 31px;
  margin-top: 20px;
  max-height: 1226px;
  margin-bottom: 30px;
}
.switchOut {
  height: 55px;
  width: 100%;
  margin-top: 15px;
}
.switchOut ul li {
  width: 66px;
  height: 25px;
  float: left;
  padding: 5px;
  text-align: center;
  line-height: 25px;
  margin-left: 10px;
  border: 2px solid #a50c0d;
  font-size: 14px;
  color: #a50c0d;
  cursor: pointer;
}
.switchOut ul {
  float: right;
}
.inTopForm table tr th:nth-child(1) {
  text-align: start;
  text-indent: 68px;
}
.inTopForm table tr td:nth-child(1) {
  text-align: start;
  text-indent: 70px;
}
.inTopForm table tr {
  height: 53px;
}
.inTopForm table tr th {
  background: #f7f8fa;
}
.inTopForm table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #eee;
}
.inTopForm tr {
  text-align: center;
}
.inTopForm tr td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.inTopForm table tr th {
  border-right: 1px solid #eee;
}
.topStyle {
  color: #fff !important;
  background: #a50c0d;
}
.theSerialNumber {
  line-height: 53px;
  width: 50px;
  margin-right: 29px;
}

.theExperimentalImages {
  position: relative;
  top: 13px;
  margin-right: 21px;
}
.turnThePage {
  height: 50px;
  margin-top: 60px;
  margin-bottom: 30px;
}
.el-breadcrumb {
  margin-top: 20px;
}
</style>